import Ajax from '../ajax';

export default {
  eventInfo: (eventId) => Ajax('get', `event/${eventId}`),
  eventList: (data) => Ajax('get', 'event', data),
  add: (data) => Ajax('post', 'event', data),
  edit: (data) => Ajax('put', `event/${data.eventId}`, data),
  delete: (eventId) => Ajax('delete', `event/${eventId}`),
};
